/* eslint-disable */


/**
 * Create styles for `<OrderDetails />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderDetails />` styles
 */
const orderDetailsStyles = ({ isLight, theme }) => ({
  dateTimeContainer: {
    marginBottom: theme.spacing(1) / 2,
  },
  deliveredTotal: {
    marginLeft: -4,
  },
  detailsContainer: {
    [`-webkit-overflow-scrolling`]: `touch`,
    overflowX: `hidden`,
    overflowY: `auto`,
    padding: theme.spacing(1) * 3,
    width: `100%`,
    maxWidth: 1407,
    [theme.breakpoints.down(`xs`)]: {
      marginTop: theme.spacing(1) * 5,
    },
  },
  detailsContainerWithSidebar: {
    [theme.breakpoints.up(`lg`)]: {
      width: `calc(100% - 260px)`, // accomodate for right hand sidebar tha will be displayed on order details page
    },
  },
  errorIcon: {
    color: `red`,
    marginRight: theme.spacing(1),
  },
  errorMessageContainer: {
    padding: theme.spacing(1),
  },
  growFull: {
    flex: `1 1 auto`,
  },
  lastUpdated: {
    color: theme.palette.grey[700],
  },
  listItemGutters: {
    backgroundColor: theme.palette.grey[200],
    marginBottom: theme.spacing(1),
  },
  loader: {
    height: 2,
  },
  modalHeading: {
    position: `relative`,
    top: 4,
  },
  section: {
    [theme.breakpoints.down(`xs`)]: {
      marginBottom: 0,
      padding: theme.spacing(1),
    },
    marginBottom: theme.spacing(1) * 3,
    padding: theme.spacing(1) * 2,
  },
  snackBarMessage: {
    color: isLight() ? theme.palette.common.white : theme.palette.common.black,
  },
  detailsItemHeading: {
    color: theme.palette.grey[500],
  },
  detailsItemIcon: {
    marginLeft: -theme.spacing(1) * 0.5,
  },
  detailsBoxItemContent: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  detailsBoxItemContainer: {
    justifyContent: `center`,
  },
});

export default orderDetailsStyles;
